var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shownProperties && _vm.shownProperties.length
    ? _c(
        "div",
        { staticClass: "orderPropertyValues" },
        _vm._l(_vm.shownProperties, function(property) {
          return _c("order-property-value-list-item", {
            key: property.propertyId,
            attrs: { property: property }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }